import MedalTitle from '~/pages/MedalTitle/pages/index/reducers'
import Medal from '../pages/Medal/pages/index/reducers'

export default {
  Medal,
  MedalTitle,
}
